import {Component, OnInit} from '@angular/core';
import {PageService} from '../../services/page.service';
import {UsuarioBc} from '../../model/usuario-bc';
import {AuthService} from '../../services/auth.service';
import {SolicitacoesService} from '../../services/solicitacoes.service';
import * as moment from 'moment';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-solicitacoes',
  templateUrl: './solicitacoes.component.html',
  styleUrls: ['./solicitacoes.component.scss']
})
export class SolicitacoesComponent implements OnInit {

  usuarioLogado: UsuarioBc;
  config: any;
  carregando = true;
  showModalDetail = false;
  showModalRequest = false;
  solicitacoes: Array<any> = [];
  solicitacoesAnalise: Array<any> = [];
  solicitacoesRespostas: Array<any> = [];
  justify = '';

  constructor(
    private pageService: PageService,
    private authService: AuthService,
    private solicitacoesService: SolicitacoesService,
    private toast: ToastrService,
  ) { }

  async ngOnInit() {
    await this.carregarDados();
  }

  private async carregarDados() {
    console.log('tentando carregar os dados -- Solicitacoes');
    try {
      this.config = await this.pageService.get('paginaPrincipal');
      this.usuarioLogado = this.authService.getUsuarioLogado();
      const cpfSemFormatacao = this.usuarioLogado.cpf.trim().replace(/\D/gi, '');
      this.solicitacoes = await this.solicitacoesService.getSolicitacoesByUsuario(cpfSemFormatacao).toPromise();
      this.solicitacoes = this.solicitacoes.filter((s) => {
        return s.portfolioSolicitado !== null;
      });
      this.solicitacoes.forEach(async (s: any) => {
        let qtdOperacoes = 0;
        if (s.portfolioSolicitado.sgPortfolio === 'PNI' || s.portfolioSolicitado.sgPortfolio === 'Novo PNI') {
          s.imagem = './assets/images/logotipos/sipni.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'RNDS') {
          s.imagem = './assets/images/logotipos/rnds.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'CNS') {
          s.imagem = './assets/images/logotipos/cnes.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'SISCAN') {
          s.imagem = './assets/images/logotipos/bnafar.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'BNAFAR') {
          s.imagem = './assets/images/logotipos/bnafar.png';
        } else if (s.portfolioSolicitado.sgPortfolio === 'e-SUSVE') {
          // s.imagem = './assets/images/logotipos/esus.png';
          s.imagem = './assets/images/logotipos/sipni.png';
        }
        for (let i = 0; i < s.portfolioSolicitado.servicos.length; i ++) {
          qtdOperacoes = qtdOperacoes + s.portfolioSolicitado.servicos[i].operacaoSolicitadas.length;
        }
        s.qtdOperacoes = qtdOperacoes;
        s.dataEnvioFormatada = s.solicitacao.dtEnvio !== null ? moment(s.solicitacao.dtEnvio).format('DD/MM/YYYY') : '-';
        let justify = await this.solicitacoesService.getJustify(s.solicitacao.idSolicitacao);
        if (justify && justify.length > 0) {
          justify = justify[justify.length - 1];
          if (justify.stAprovacao == "N") {
            s.justify = justify.dsJustificativaAprovacao;
          }
        }
      });
      this.solicitacoesAnalise = this.solicitacoes.filter((s: any) => {
        return s.solicitacao.stSolicitacao === 'ENVIADA';
      });
      this.solicitacoesRespostas = this.solicitacoes.filter((s: any) => {
        return s.solicitacao.stSolicitacao === 'DEFERIDA_PARCIALMENTE'
          || s.solicitacao.stSolicitacao === 'TESTANDO_HOMOLOG'
          || s.solicitacao.stSolicitacao === 'TESTANDO_PRODUC'
          || s.solicitacao.stSolicitacao === 'INDEFERIDA';
      });
      this.solicitacoesAnalise.sort(this.orderDtEnvio);
      this.solicitacoesRespostas.sort(this.orderDtEnvio);
      this.carregando = false;
    } catch ( e ) {
      console.log(e);
      this.solicitacoesAnalise = [];
      this.solicitacoesRespostas = [];
      this.toast.error('Ocorreu um erro ao buscar as solicitações');
      this.carregando = false;
    }
    console.log(this.solicitacoesAnalise);
    console.log(this.solicitacoesRespostas);
  }


  openJustify (justify) {
    this.justify = justify;
    this.showModalDetail = true;
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  orderDtEnvio(a, b) {
    if (a.solicitacao.dtEnvio > b.solicitacao.dtEnvio) {
      return -1;
    }
    if (a.solicitacao.dtEnvio < b.solicitacao.dtEnvio) {
      return 1;
    }
    return 0;
  }

  fecharModaDetail() {
    this.showModalDetail = false;
  }


  fecharModaRequest() {
    this.showModalRequest = false;
  }

  modalsolicitar(){
    this.showModalRequest = true;

  }

}



// WEBPACK FOOTER //
// ./src/app/components/solicitacoes/solicitacoes.component.ts